import styled from '@emotion/styled';

import { COLOR_BORDER, COLOR_SURFACE_TOOLBAR } from './utils/variables';

export const CardToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 14px 16px;
  border-bottom: 1px solid ${COLOR_BORDER};
  background: ${COLOR_SURFACE_TOOLBAR};
`;
